/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export interface NameInfoVO {
  /**
   * first name of a customer/passenger
   */
  firstName?: string;
  /**
   * last name of a customer/passenger
   */
  lastName?: string;
  /**
   * middle name of a customer/passenger
   */
  middleName?: string;
  /**
   * preferred first name or nickname of a customer/passenger
   */
  preferredName?: string;
  /**
   * prefix of a customer/passenger
   */
  prefix?: string;
  /**
   * suffix of a customer/passenger
   */
  suffix?: string;
}
